import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from '../../ChatConsoleView.module.scss';
import chatLoader from '../assets/chat-loader.gif';
import UserRequest from '../user-request/UserRequest';
import BotResponse from '../bot-response/BotResponse';
import ChatInput from '../chat-input/ChatInput';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import ChatHeader from '../chat-header/ChatHeader';
import { useUserContext } from 'app-context/user/UserContext';

const validationSchema = Yup.object().test(
  'at-least-one-field',
  'At least one field (Question, image, file, or audio) is required',
  (values) => {
    if (!values) return false;
    return (
      (values.Question && values.Question.trim().length > 0) ||
      (values.images && values.images.length > 0) ||
      (values.files && values.files.length > 0) ||
      !!values.audio
    );
  },
);
const ChatBody = ({
  isOpen,
  isFetchingChat,
  isChatting,
  isWorkFlow,
  guestChat,
  userData,
  hasSidebar,
  chatId,
  bot,
  isSubmitChatLoading,
  capture,
  handleSubmit,
  className,
  chattingClassName,
  inputContainerClass,
  bodyClassName,
  forceResetForm,
  setGuestChat,
  setCapture,
  setSuggestedQuestions,
  suggestedQuestions,
  botSettingsData,
  isExpanded,
  restartForm,
  disableConsole,
  isConversation,
  idleTime,
  handleIdleSubmit,
  triggerNewConversation,
  chatBodyClassname,
  isStreaming,
  isUserChat,
  chatsData,
  onNewChatClick,
  onChatSelect,
  isFullConversation,
}) => {
  const { selectedBot } = useUserContext();
  //// for testing
  const [timer, setTimer] = useState(0);
  const intervalRef = useRef(null);
  //// for testing

  const idleTimerRef = useRef(null);
  const chatContainerRef = useRef(null);
  const responseRef = useRef(null);
  const suggestedQuestionsRef = useRef(null);
  const [hasActiveForm, setHasActiveForm] = useState(false);
  const [isIdleCalledLast, setIsIdleCalledLast] = useState(false);
  const [autoScroll, setAutoScroll] = useState(true);

  const getScroller = () =>
    hasSidebar ? chatContainerRef.current : responseRef.current;

  const scrollToBottom = (behavior = 'auto', opts) => {
    const force = !!opts?.force;
    if (!force && !autoScroll) return;
    const el = getScroller();
    if (el) {
      try {
        el.scrollTo({ top: el.scrollHeight, behavior });
      } catch {
        el.scrollTop = el.scrollHeight;
      }
    }
  };
  const formik = useFormik({
    initialValues: { Question: '', images: [], files: [], audio: null },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      setAutoScroll(true);
      const el = responseRef.current || chatContainerRef.current;
      if (el) {
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      }
      handleSubmit(values);
      formik.setFieldValue('audio', null);

      resetForm();
      setIsIdleCalledLast(false);
    },
  });
  useEffect(() => {
    if (!guestChat?.messages?.length) return;

    setAutoScroll(true);
    const el = getScroller();
    if (!el) return;

    el.scrollTop = el.scrollHeight;

    const raf = requestAnimationFrame(() => {
      scrollToBottom('smooth', { force: true });
    });

    const t = setTimeout(() => {
      scrollToBottom('smooth', { force: true });
    }, 200);

    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
    };
  }, [guestChat?.messages?.length, chatId]);
  useEffect(() => {
    formik.resetForm();
  }, [forceResetForm]);

  //   if (
  //     guestChat?.messages?.length > 0 &&
  //     chatContainerRef.current &&
  //     hasSidebar
  //   ) {
  //     chatContainerRef.current.scrollTo({
  //       top: chatContainerRef.current.scrollHeight,
  //       behavior: 'smooth',
  //     });
  //   }
  //   if (guestChat?.messages?.length > 0 && responseRef.current && !hasSidebar) {
  //     responseRef.current.scrollTo({
  //       top: responseRef.current.scrollHeight,
  //       // behavior: 'smooth',
  //     });
  //   }
  // };
  // useEffect(() => {
  //   toBottom();
  //   setTimeout(() => {
  //     toBottom();
  //   }, 100);
  // }, [guestChat]);
  useEffect(() => {
    scrollToBottom('auto');
    const id = requestAnimationFrame(() => scrollToBottom('smooth'));
    const t = setTimeout(() => scrollToBottom('smooth'), 100);
    return () => {
      cancelAnimationFrame(id);
      clearTimeout(t);
    };
  }, [guestChat, autoScroll, hasSidebar]);

  useEffect(() => {
    const el = getScroller();
    if (!el) return;

    const stopAuto = () => setAutoScroll(false);

    el.addEventListener('wheel', stopAuto, { passive: true });
    el.addEventListener('touchstart', stopAuto, { passive: true });
    el.addEventListener('mousedown', stopAuto);

    return () => {
      el.removeEventListener('wheel', stopAuto);
      el.removeEventListener('touchstart', stopAuto);
      el.removeEventListener('mousedown', stopAuto);
    };
  }, [hasSidebar, guestChat?.messages?.length]);

  useEffect(() => {
    const updateHeight = () => {
      let height = 0;

      if (suggestedQuestionsRef.current && suggestedQuestions.length > 0) {
        height = suggestedQuestionsRef.current.offsetHeight;
      }

      document.documentElement.style.setProperty(
        '--suggested-questions-height',
        `${height}px`,
      );
    };
    updateHeight();

    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, [suggestedQuestions, guestChat]);
  const resetIdleTimer = useCallback(() => {
    if (!isOpen || !idleTime || hasActiveForm || isIdleCalledLast) return;

    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    setTimer(0);
    intervalRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev >= idleTime - 1) {
          clearInterval(intervalRef.current);
          return idleTime;
        }
        return prev + 1;
      });
    }, 1000);

    idleTimerRef.current = setTimeout(() => {
      if (guestChat?.chatID) {
        setIsIdleCalledLast(true);
        handleIdleSubmit();
      }
    }, idleTime * 1000);
  }, [isOpen, idleTime, hasActiveForm, guestChat?.chatID, handleIdleSubmit]);

  useEffect(() => {
    resetIdleTimer();
    return () => {
      clearTimeout(idleTimerRef.current);
      clearInterval(intervalRef.current);
    };
  }, [
    resetIdleTimer,
    formik.values.Question,
    formik.values.audio,
    JSON.stringify(formik.values.files),
    JSON.stringify(formik.values.images),
  ]);
  const bodyView = (
    <div
      className={`${styles['chat-body']} ${
        disableConsole ? styles['chat-body-full'] : null
      } ${isChatting ? styles['chat-on'] : ''} ${bodyClassName}`}
      style={{ position: !isWorkFlow ? 'relative' : '' }}
    >
      {isFetchingChat && !isWorkFlow && (
        <div className={styles['chat-loader']}>
          <img src={chatLoader} alt='Loading...' />
        </div>
      )}
      {/* <div
        ref={chatContainerRef}
        className={`${styles['start-chat-container']} ${
          isWorkFlow ? styles['tryMe'] : ''
        } ${!isChatting ? styles['opened'] : ''} ${className ?? ''}`}
      > */}
      <div
        ref={chatContainerRef}
        className={`${styles['chatting-body']} ${chattingClassName} ${
          isWorkFlow ? styles['try-me'] : ''
        }`}
      >
        <div
          className={`${styles['chat-response']} ${
            isWorkFlow ? styles['workflow-response'] : ''
          }`}
          ref={responseRef}
        >
          {guestChat?.messages.map((val, index) => {
            if (chatId !== guestChat?.chatID) return;
            const textFromArray = Array.isArray(val?.content)
              ? val.content
                  .map((c) => (typeof c?.value === 'string' ? c.value : ''))
                  .join(' ')
                  .trim()
              : null;
            const textFromString =
              typeof val?.content === 'string' ? val.content.trim() : '';

            const normalized = (textFromArray ?? textFromString) || '';

            if (val.role === 'user' && normalized.length === 0) {
              return null;
            }
            return val.role === 'user' ? (
              <UserRequest
                key={`${val.stepId}-${index}`}
                chatData={val}
                userData={userData}
              />
            ) : (
              <BotResponse
                key={`${val.stepId ?? 'no-step'}-${index}`}
                chatData={val}
                isWorkFlow={isWorkFlow}
                isRequesting={isSubmitChatLoading}
                chatId={chatId}
                botId={bot}
                setGuestChat={setGuestChat}
                setCapture={setCapture}
                guestChat={guestChat}
                setSuggestedQuestions={setSuggestedQuestions}
                settings={botSettingsData}
                isExpanded={isExpanded}
                direction={guestChat.direction}
                restartForm={restartForm}
                disableConsole={disableConsole}
                isConversation={isConversation}
                onHasFormChange={setHasActiveForm}
                triggerNewConversation={triggerNewConversation}
                selectedBot={selectedBot}
              />
            );
          })}
        </div>
        {/* {suggestedQuestions?.length > 0 && !isSubmitChatLoading && (
          <div
            ref={suggestedQuestionsRef}
            className={styles['suggested-questions']}
          >
            {suggestedQuestions?.map((val, index) => {
              if (val === '') return;
              return (
                <div key={index} className={styles['questions-response']}>
                  <div
                    key={`question-${index}`}
                    className={styles['question']}
                    onClick={() => {
                      if (isRequesting) return;
                      formik.setFieldValue('Question', val);
                      formik.handleSubmit();
                    }}
                  >
                    <p>{val}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )} */}
      </div>
      {/* </div> */}
      {!disableConsole ? (
        <div
          className={`${styles['chat-input-container']} ${inputContainerClass}`}
        >
          <ChatInput
            // key={index}
            isRequesting={isSubmitChatLoading || isStreaming}
            capture={capture}
            submitForm={handleSubmit}
            isSubmitChatLoading={isSubmitChatLoading}
            forceResetForm={forceResetForm}
            hasSidebar={hasSidebar}
            settings={botSettingsData?.data}
          />
        </div>
      ) : null}
    </div>
  );
  return (
    <FormikProvider value={formik}>
      {isFetchingChat && isWorkFlow && (
        <div className={styles['chat-loader']}>
          <img src={chatLoader} alt='Loading...' />
        </div>
      )}
      {isWorkFlow || disableConsole ? (
        bodyView
      ) : (
        <div className={!isWorkFlow ? styles['body'] : null}>
          {!isWorkFlow && (
            <div className={styles.header}>
              <ChatHeader
                title='Lebanese American University'
                selectedBot={selectedBot}
                isUserChat={isUserChat}
              />
            </div>
          )}
          {bodyView}
        </div>
      )}
      {/* {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: 10,
            left: 10,
            fontSize: '0.8rem',
            color: 'gray',
          }}
        >
          Idle Timeout: {timer}s / {idleTime}s
        </div>
      )} */}
    </FormikProvider>
  );
};

export default ChatBody;
